import axios from 'axios';
import {APIUrl} from '../constants/ApplicationConstants.js';
import actions from '../actions/OnlineAccessApiCallBackActions.js';
import {getError as Error, ThrowIfStatusNotOk} from './ApiHelper.js';

module.exports = {
    validatePin: function(pin, index) {
        const url = APIUrl.VALIDATE_PIN + '?pin=' + pin;

        axios.get(url)
            .then(ThrowIfStatusNotOk)
            .then((response) => {
                actions.pinValidated(response.data, index);
            })
            .catch((error) => {
                actions.pinValidatedError(index);
                throw Error('Online Access PIN', error);
            });
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./apis/OnlineAccessAPI.js